import React from 'react';
import ButtonLanguage from 'components/Button-Language';
import { Container, Texthome } from 'css/Styled-sso';

export const LayoutApp = ({ children, bg, typeBg }) => {

    return (
        <>
        <Container bg={bg} typeBg={typeBg}>
            {/* <ButtonLanguage /> */}
            {children}
            {/* <Texthome>Privacy Notice • Cookie Notice • Terms of use <br/> Copyright 2022 © SCG Chemicals</Texthome> */}
            {/* <Texthome>Privacy Notice • Cookie Notice</Texthome> */}
        </Container>
        </>
    )
}